<template>
<div>
	<div>
		<div class="col-lg-12">
			<h2 class="page-header">
				<span id="page-header">{{ pageheader }}</span>
				<a href="/roles/" class="hidden-md hidden-lg"><button class="btn btn-success">Zur Liste</button></a>
			</h2>

			<div class="row">
				<h3 class="col-lg-12">Allgemeine Informationen  <router-link class="btn btn-primary create-new pull-right" to="/roles/new"><i class="fa fa-plus"></i></router-link></h3>
				<div class="form-horizontal" id="customer-information">

					<div class="row">
						<div class="col-lg-12">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="firstname">Bezeichnung</label>
								<div class="col-sm-12">
									<input id="firstname" name="firstname" class="form-control" v-model="model.model.name" required>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="form-group">
							<div class="col-lg-12 text-center">
								<a href="/roles/" class="hidden-sm hidden-xs"><button class="btn btn-success">Zur Liste</button></a>
								<button class="btn btn-primary" @click="saveRole()">Speichern</button>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-lg-12">
							<div class="col-lg-12">
								<ul class="nav nav-tabs responsive-tabs">
									<li class="active"><a href="#addresses">Berechtigungen</a></li>
									<li><a href="#users" v-show="model.model.id > 0">Benutzer</a></li>
								</ul>

								<div class="tab-content col-lg-12">
									<div class="tab-pane active" id="addresses">
										<table class="table table-striped table-hover">
											<thead>
											<tr>
												<th style="width: 200px">Bereich</th>
												<th>Berechtigungsstufe</th>
											</tr>
											</thead>
											<tbody>
											<tr>
												<td>Dashboard</td>
												<td>
													<vue-slider ref="dashboard" @callback="changeIndex('dashboard')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.dashboard"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Verstorbene</td>
												<td>
													<vue-slider ref="deceaseds" @callback="changeIndex('deceaseds')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.deceaseds"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Kunden</td>
												<td>
													<vue-slider ref="customers" @callback="changeIndex('customers')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.customers"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Gräber</td>
												<td>
													<vue-slider ref="graves" @callback="changeIndex('graves')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.graves"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Flächen</td>
												<td>
													<vue-slider ref="areas" @callback="changeIndex('areas')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.areas"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Krematorien</td>
												<td>
													<vue-slider ref="crematories" @callback="changeIndex('crematories')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.crematories"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Bestatter</td>
												<td>
													<vue-slider ref="undertakers" @callback="changeIndex('undertakers')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.undertakers"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Benutzerverwaltung</td>
												<td>
													<vue-slider ref="users" @callback="changeIndex('users')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.users"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Rollen</td>
												<td>
													<vue-slider ref="roles" @callback="changeIndex('roles')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.roles"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Flächenarten</td>
												<td>
													<vue-slider ref="area_categories" @callback="changeIndex('area_categories')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.area_categories"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Grabarten</td>
												<td>
													<vue-slider ref="grave_categories" @callback="changeIndex('grave_categories')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.grave_categories"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Bestattungsarten</td>
												<td>
													<vue-slider ref="burial_types" @callback="changeIndex('burial_types')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.burial_types"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Konfessionen</td>
												<td>
													<vue-slider ref="denominations" @callback="changeIndex('denominations')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.denominations"></vue-slider>
												</td>
											</tr>
											<tr>
												<td>Friedhofsverwaltung</td>
												<td>
													<vue-slider ref="graveyards" @callback="changeIndex('graveyards')" v-bind="sliderTemplate" v-model="model.model.permissionsValues.graveyards"></vue-slider>
												</td>
											</tr>
											</tbody>
										</table>
									</div>

									<div class="tab-pane" id="users" v-show="model.model.id > 0">
										<custom-table :cols="userCols" :src-model="model.users" add delete select="/users/{:id}" nosort @add="addRelation('users')" @delete="deleteUser"></custom-table>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- Benutzer -->
		<custom-modal v-if="visibleModal === 'addusers'" title="Benutzer auswählen" @cancel="visibleModal = ''">
			<div class="row">
				<div class="col-lg-12">
					<!-- @multiselect="multiSelectUsers" multiselect="Hinzufügen"-->
					<custom-table select @select="pickUser" :src-model="$store.getters.models('users')" :cols="superiorSearchCols" store="users" search :default-sort="defSort"></custom-table>
				</div>
			</div>
		</custom-modal>

	</div>
</div>

</template>

<script>
import CustomTable from 'components/custom-table.vue'
import CustomModal from 'components/custom-modal-old.vue'
import CustomInput from 'components/custom-input.vue'

import Datepicker from 'vuejs-datepicker'
import vueSlider from 'vue-slider-component';

import RoleModel from 'models/roles.js'
import UserModel from 'models/users.js'

import modelTools from 'functions/models.js'
import relationTools from 'functions/relations.js'
import roleTools from 'functions/roles.js'

import store from 'root/store.js'
import { authCheck, getSuperiorID } from 'functions/auth_check.js'

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('roles')
		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	beforeRouteLeave(to, from, next) {
		if (to.path === '/'+this.model.name+'/new') {
			this.model.clear(1)
			this.refreshSliders()
		}
		next()
	},

	// Normale Eigenschaften
	data () {
		return {
			model: RoleModel,
			users: UserModel,

			roleSearchCols: [
				{
					name: 'Name',
					json: 'name',
					type: 'text'
				},
				{
					name: 'Preis',
					json: 'price',
					type: 'float'
				}
			],

			userCols: [
				{
					name: 'Vorname',
					json: 'firstname',
					type: 'text'
				},
				{
					name: 'Nachname',
					json: 'lastname',
					type: 'text'
				},
				{
					name: 'Benutzername',
					json: 'username',
					type: 'text'
				}
			],

			superiorSearchCols: [
				{
					name: 'Vorname',
					json: 'firstname',
					type: 'text'
				},
				{
					name: 'Nachname',
					json: 'lastname',
					type: 'text'
				}
			],

			// visibleModal: 'addgraves'
			visibleModal: '',

			defSort: {col: 'id', order: 'asc'},

			sliderCols: '["Kein Zugriff", "Lesen", "Ändern", "Löschen"]',

			sliderTemplate: {
				width: "90%",
				realTime: true,
				tooltip: "hover",
				disabled: false,
				piecewise: true,
				piecewiseLabel: true,
				show: true,
				data: [
					"Kein Zugriff",
					"Lesen",
					"Ändern",
					"Löschen"
				],
				piecewiseStyle: {
					"backgroundColor": "#ccc",
					"visibility": "visible",
					"width": "12px",
					"height": "12px"
				},
				piecewiseActiveStyle: {
					"backgroundColor": "#3498db"
				},
				labelActiveStyle: {
					"color": "#3498db"
				}
			}
		}
	},

	activated () {
		$(this.$refs.areaManagementRights).on('shown.bs.collapse', () => {
			this.refreshSliders()
		})
		$(this.$refs.areaSettingRights).on('shown.bs.collapse', () => {
			this.refreshSliders()
		})

		$('.collapse').collapse('hide')

		this.model.clear(1)
		this.model.model.id = parseInt(this.$route.params.id)
		if (isNaN(this.model.model.id)) {
			this.model.model.id = 0
		}

		this.$store.dispatch('loadModel', 'roles')
		.then(() => {
			var model = this.$store.getters.model('roles', this.model.model.id)
			this.model.copy(model)

			this.$store.dispatch('loadRelation', {basis: this.model, relation: 'users'})
			.then(data => this.initRelation('users', data))

			this.$store.dispatch('loadModels', this.model.relations)
			.then(() => {
				const currentRole = this.$store.getters.model('roles', this.model.model.role_id)
				const names = [
					"Aus Rolle übernehmen",
					"Kein Zugriff",
					"Lesen",
					"Ändern",
					"Löschen"
				]
			})

			$('.responsive-tabs').responsiveTabs({
				accordionOn: ['xs', 'sm'] // xs, sm, md, lg
			})
		})
	},

	computed: {
		pageheader () {
			let model
			let name

			if (this.model.model.id === 0) {
				return 'Neue Rolle anlegen'
			} else {
				model = this.$store.getters.model('roles', this.model.model.id)
				name = model.name

				return 'Rolle "' + name.trim() + '" verwalten'
			}
		}
	},

	components: {
		CustomTable,
		CustomModal,
		CustomInput,
		Datepicker,
		vueSlider
	},

	methods: {
		// Tools des Models
		saveModel: modelTools.save,

		// Beziehungen zwischen Models
		initRelation: relationTools.init,
		editRelation: relationTools.edit,
		deleteRelation: relationTools.delete,
		addRelation: relationTools.add,
		saveRelation: relationTools.save,
		confirmDeleteRelation: relationTools.confirmDelete,

		// Kontakt speziefische Methoden
		editRole: roleTools.edit,
		deleteRole: roleTools.delete,

		selectUser () {
			this.visibleModal = 'selectuser'
		},

		multiSelectUsers (aUsers) {
			//
		},

		deleteUser (aModel) {
			this.users.copy(aModel)
			this.deleteRelation('users')
		},

		pickRole (aModel) {
			this.model.model.role_id = aModel.id
			this.model.model.role_name = aModel.name
			this.visibleModal = ''
		},

		pickUser (aModel) {
			console.log(aModel)
			this.users.copy(aModel)
			this.saveRelation('users')
			this.visibleModal = ''
		},

		refreshSliders () {
			console.log(this.model.model.permissions.roles)

			this.$refs.dashboard.setIndex(this.model.model.permissions.dashboard - 1)
			this.$refs.deceaseds.setIndex(this.model.model.permissions.deceaseds - 1)
			this.$refs.customers.setIndex(this.model.model.permissions.customers - 1)
			this.$refs.graves.setIndex(this.model.model.permissions.graves - 1)
			this.$refs.areas.setIndex(this.model.model.permissions.areas - 1)
			this.$refs.crematories.setIndex(this.model.model.permissions.crematories -1)
			this.$refs.undertakers.setIndex(this.model.model.permissions.undertakers - 1)
			this.$refs.users.setIndex(this.model.model.permissions.users - 1)
			this.$refs.roles.setIndex(this.model.model.permissions.roles - 1)

			this.$refs.area_categories.setIndex(this.model.model.permissions.area_categories - 1)
			this.$refs.grave_categories.setIndex(this.model.model.permissions.grave_categories - 1)
			this.$refs.burial_types.setIndex(this.model.model.permissions.burial_types - 1)
			this.$refs.denominations.setIndex(this.model.model.permissions.denominations - 1)
			this.$refs.graveyards.setIndex(this.model.model.permissions.graveyards - 1)


			this.$refs.dashboard.refresh()
			this.$refs.deceaseds.refresh()
			this.$refs.customers.refresh()
			this.$refs.graves.refresh()
			this.$refs.areas.refresh()
			this.$refs.crematories.refresh()
			this.$refs.undertakers.refresh()
			this.$refs.users.refresh()
			this.$refs.roles.refresh()

			this.$refs.area_categories.refresh()
			this.$refs.grave_categories.refresh()
			this.$refs.burial_types.refresh()
			this.$refs.denominations.refresh()
			this.$refs.graveyards.refresh()
		},

		changeIndex(aSlider) {
			this.model.model.permissions[aSlider] = this.$refs[aSlider].getIndex() + 1
		},

		saveRole () {
			console.log('saveRole')

  			let permissions = {
				deceaseds: this.model.model.permissions.deceaseds,
				customers: this.model.model.permissions.customers,
				graves: this.model.model.permissions.graves,
				areas: this.model.model.permissions.areas,
				settings: this.model.model.permissions.settings,
				crematories: this.model.model.permissions.crematories,
				undertakers: this.model.model.permissions.undertakers
			}

			this.saveModel()
			.then(id => {
				const currentRole = this.$store.getters.model('roles', id)
				this.model.copy(currentRole)
				this.$router.replace("/roles/" + id)
			})
			.catch(id => {
				this.model.model.id = id
			})
		},

		isSuperadmin () {
			const SuperiorID = getSuperiorID()
			return (SuperiorID === 0) || (SuperiorID === 1)
		}
	}
}
</script>



// WEBPACK FOOTER //
// RoleEdit.vue?7df26344